import { render, staticRenderFns } from "./TabDevis.vue?vue&type=template&id=4f9bdca3&scoped=true"
import script from "./TabDevis.vue?vue&type=script&lang=js"
export * from "./TabDevis.vue?vue&type=script&lang=js"
import style0 from "./TabDevis.vue?vue&type=style&index=0&id=4f9bdca3&prod&scoped=true&lang=css"
import style1 from "./TabDevis.vue?vue&type=style&index=1&id=4f9bdca3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9bdca3",
  null
  
)

export default component.exports